<div class="slider-form-container">
  <!-- Fixed Header -->
  <div class="slider-form-header">
    <div class="form-banner">
      <img class="ban1" src="assets/images/formbanner1.svg" alt="Form Banner" />

      <div class="banner-text">
        <h2 class="form-title">Edit Profile</h2>
        <p>Update Team Member</p>
      </div>
      <img class="ban2" src="assets/images/formbanner2.svg" alt="Form Banner" />
      <button (click)="onClose()" class="close-button" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <!-- Scrollable Content -->
  <div class="slider-form-content-wrapper">
    <div class="slider-form-content">
      <form (ngSubmit)="onSubmit()" class="edit-people-form">
        <div class="form_field_wrapper">
          <input type="text" name="personName" required placeholder=" " maxlength="120" class="form-control"
            [formControl]="personNameControl" appPreventLeadingSpace />
          <label class="floating_label">Full Name *</label>
          <div class="mat-error" *ngIf="personNameControl.hasError('required') && personNameControl.touched">
            Please enter the Full Name
          </div>
        </div>

        <div class="form_field_wrapper">
          <input readonly type="email" name="email" required placeholder=" " maxlength="120" class="form-control"
            [formControl]="emailControl" appPreventLeadingSpace />
          <label class="floating_label">Email *</label>
          <div class="mat-error" *ngIf="emailControl.hasError('required') && emailControl.touched">
            Please enter the Email
          </div>
          <div class="mat-error" *ngIf="emailControl.hasError('email') && emailControl.touched">
            Please enter a valid Email
          </div>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <input type="text" name="phone" placeholder=" " maxlength="20" class="form-control"
              [formControl]="phoneControl" appPreventLeadingSpace />
            <label class="floating_label">Phone</label>
          </div>

          <div class="form_field_wrapper half-width">
            <div class="date_wrap">
              <input matInput [matDatepicker]="dobPicker" [formControl]="dobControl" name="dateOfBirth" placeholder=" "
                class="form-control" (click)="dobPicker.open()" readonly />
              <mat-datepicker-toggle matSuffix [for]="dobPicker">
                <i matDatepickerToggleIcon class="wl_icon_calendar"></i>
              </mat-datepicker-toggle>
              <mat-datepicker #dobPicker></mat-datepicker>
            </div>
            <label class="floating_label">Date of Birth</label>
          </div>
        </div>

        <!-- <div class="form_field_wrapper">
          <ng-select
            [items]="companies()"
            bindLabel="name"
            bindValue="_id"
            [formControl]="companyControl"
            name="company"
            class="modal-ng-select"
            [searchable]="true"
            [clearable]="true"
          >
          </ng-select>
          <label class="floating_label">Select Company</label>
        </div> -->

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <input type="text" name="jobTitle" placeholder=" " maxlength="100" class="form-control"
              [formControl]="jobTitleControl" appPreventLeadingSpace />
            <label class="floating_label">Job Title</label>
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select [items]="jobRoles()" bindLabel="jobrole" bindValue="_id" [formControl]="jobRoleControl"
              name="jobRole" class="modal-ng-select" [searchable]="true" [clearable]="true">
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  <span class="role-name">{{ item.jobrole }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No job roles found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Job Role</label>
          </div>
        </div>

        <div class="form_field_wrapper full-width">
          <textarea name="address" rows="3" maxlength="500" placeholder=" " class="form-control"
            [formControl]="addressControl"></textarea>
          <label class="floating_label">Address</label>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <ng-select [items]="timezoneOptions" bindLabel="label" bindValue="value" [formControl]="timezoneControl"
              name="timezone" class="modal-ng-select" [searchable]="true" [clearable]="true">
            </ng-select>
            <label class="floating_label">Timezone</label>
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select [items]="homeTeams()" bindLabel="teamName" bindValue="_id" [formControl]="homeTeamControl"
              name="homeTeam" class="modal-ng-select" [searchable]="true" [clearable]="true">
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  <span class="team-name">{{ item.teamName }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No teams found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Home Team</label>
          </div>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <ng-select [items]="managers()" bindLabel="name" bindValue="_id" [formControl]="managerControl"
              name="manager" class="modal-ng-select" [searchable]="true" [clearable]="true">
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  @if (item.avatar) {
                  <img [src]="item.avatar" class="user-avatar" />
                  }
                  <span class="user-name">{{ item.name }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No managers found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Select Manager</label>
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select [items]="accessLevelOptions" bindLabel="accesslevel_name" bindValue="_id"
              [formControl]="accessLevelControl" name="accessLevel" class="modal-ng-select" [searchable]="false"
              [clearable]="true">
            </ng-select>
            <label class="floating_label">Select Access Level</label>
          </div>
        </div>

        <!-- Active Status Toggle -->
        <!-- <div class="form_field_wrapper full-width">
          <div class="toggle-field">
            <div class="toggle-container">
              <label class="toggle-label">Active Status</label>
              <div class="toggle-wrapper">
                <button
                  type="button"
                  class="toggle-button"
                  [class.active]="isActiveControl.value"
                  (click)="toggleActiveStatus()"
                >
                  <span class="toggle-slider"></span>
                 
                </button>
                <span class="toggle-text">{{ isActiveControl.value ? 'Active' : 'Inactive' }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="form_field_wrapper full-width">
          <textarea
            name="description"
            rows="3"
            maxlength="500"
            placeholder=" "
            class="form-control"
            [formControl]="descriptionControl"
          ></textarea>
          <label class="floating_label">Description</label>
        </div> -->
      </form>
    </div>
  </div>

  <!-- Fixed Actions -->
  <div class="slider-form-actions">
    <button mat-flat-button type="submit" (click)="onSubmit()" [disabled]="!isFormValid() || isLoading"
      class="btn-save">
      <div class="button-content">
        <app-spinner *ngIf="isLoading" [size]="20"></app-spinner>
        <span *ngIf="!isLoading">Update Person</span>
      </div>
    </button>
    <button mat-stroked-button type="button" (click)="onClose()" class="btn-cancel">
      <span>Cancel</span>
    </button>
  </div>
</div>